import { darkPalette, lightPalette, } from '@uipath/apollo-core';
import { MuiAlert } from './MuiAlert';
import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiButton } from './MuiButton';
import { MuiChip } from './MuiChip';
import { MuiCircularProgress } from './MuiCircularProgress';
import { MuiDialog } from './MuiDialog';
import { MuiDivider } from './MuiDivider';
import { MuiFab } from './MuiFab';
import { MuiFormControl } from './MuiFormControl';
import { MuiFormControlLabel } from './MuiFormControlLabel';
import { MuiFormHelperText } from './MuiFormHelperText';
import { MuiFormLabel } from './MuiFormLabel';
import { MuiIconButton } from './MuiIconButton';
import { MuiInputAdornment } from './MuiInputAdornment';
import { MuiInputBase } from './MuiInputBase';
import { MuiInputLabel } from './MuiInputLabel';
import { MuiLinearProgress } from './MuiLinearProgress';
import { MuiLink } from './MuiLink';
import { MuiList } from './MuiList';
import { MuiListItem } from './MuiListItem';
import { MuiListItemIcon } from './MuiListItemIcon';
import MuiListItemText from './MuiListItemText';
import { MuiMenuItem } from './MuiMenuItem';
import { MuiOutlinedInput } from './MuiOutlinedInput';
import { MuiSelect } from './MuiSelect';
import { MuiSlider } from './MuiSlider';
import MuiSnackbar from './MuiSnackbar';
import { MuiTab } from './MuiTab';
import { MuiTabs } from './MuiTabs';
import { MuiTextField } from './MuiTextField';
import { MuiTooltip } from './MuiTooltip';
import { MuiTypography } from './MuiTypography';
export const lightOverrides = {
    MuiAutocomplete: MuiAutocomplete(lightPalette),
    MuiButton: MuiButton(lightPalette),
    MuiCircularProgress: MuiCircularProgress(lightPalette),
    MuiLinearProgress: MuiLinearProgress(lightPalette),
    MuiDivider: MuiDivider(lightPalette),
    MuiSlider: MuiSlider(),
    MuiSelect: MuiSelect(lightPalette),
    MuiListItem: MuiListItem(lightPalette),
    MuiFormControlLabel: MuiFormControlLabel(lightPalette),
    MuiIconButton: MuiIconButton(lightPalette),
    MuiListItemIcon: MuiListItemIcon(lightPalette),
    MuiOutlinedInput: MuiOutlinedInput(lightPalette),
    MuiInputBase: MuiInputBase(lightPalette),
    MuiTab: MuiTab(lightPalette),
    MuiTabs: MuiTabs(lightPalette),
    MuiTooltip: MuiTooltip(lightPalette),
    MuiTypography: MuiTypography(lightPalette),
    MuiTextField: MuiTextField(lightPalette),
    MuiInputLabel: MuiInputLabel(lightPalette),
    MuiFormHelperText: MuiFormHelperText(lightPalette),
    MuiFormLabel: MuiFormLabel(lightPalette),
    MuiInputAdornment: MuiInputAdornment(),
    MuiFormControl: MuiFormControl(lightPalette),
    MuiChip: MuiChip(lightPalette),
    MuiMenuItem: MuiMenuItem(lightPalette),
    MuiList: MuiList(lightPalette),
    MuiListItemText,
    MuiLink: MuiLink(lightPalette),
    MuiAlert: MuiAlert(lightPalette),
    MuiSnackbar,
    MuiDialog: MuiDialog(lightPalette),
    MuiFab: MuiFab(lightPalette),
};
export const darkOverrides = {
    MuiAutocomplete: MuiAutocomplete(darkPalette),
    MuiButton: MuiButton(darkPalette),
    MuiCircularProgress: MuiCircularProgress(darkPalette),
    MuiLinearProgress: MuiLinearProgress(darkPalette),
    MuiDivider: MuiDivider(darkPalette),
    MuiSlider: MuiSlider(),
    MuiSelect: MuiSelect(darkPalette),
    MuiListItem: MuiListItem(darkPalette),
    MuiFormControlLabel: MuiFormControlLabel(darkPalette),
    MuiListItemIcon: MuiListItemIcon(darkPalette),
    MuiIconButton: MuiIconButton(darkPalette),
    MuiOutlinedInput: MuiOutlinedInput(darkPalette),
    MuiInputBase: MuiInputBase(darkPalette),
    MuiTab: MuiTab(darkPalette),
    MuiTabs: MuiTabs(darkPalette),
    MuiTooltip: MuiTooltip(darkPalette),
    MuiTypography: MuiTypography(darkPalette),
    MuiTextField: MuiTextField(darkPalette),
    MuiInputLabel: MuiInputLabel(darkPalette),
    MuiFormHelperText: MuiFormHelperText(darkPalette),
    MuiFormLabel: MuiFormLabel(darkPalette),
    MuiInputAdornment: MuiInputAdornment(),
    MuiFormControl: MuiFormControl(darkPalette),
    MuiChip: MuiChip(darkPalette),
    MuiMenuItem: MuiMenuItem(darkPalette),
    MuiList: MuiList(darkPalette),
    MuiListItemText,
    MuiLink: MuiLink(darkPalette),
    MuiAlert: MuiAlert(darkPalette),
    MuiSnackbar,
    MuiDialog: MuiDialog(darkPalette),
    MuiFab: MuiFab(darkPalette),
};
